module.exports = __webpack_public_path__ + "img/raw.6e7dd11f.svg";